/**
 * CSS Constants
 */
/** @hidden */
export var root = 'e-gantt';
export var ganttChartPane = 'e-gantt-chart-pane';
export var treeGridPane = 'e-gantt-tree-grid-pane';
export var splitter = 'e-gantt-splitter';
export var ganttChart = 'e-gantt-chart';
export var ganttSingleTimeline = 'e-gantt-single-timeline';
export var chartBodyContainer = 'e-chart-root-container';
export var toolbar = 'e-gantt-toolbar';
export var chartScrollElement = 'e-chart-scroll-container';
export var chartBodyContent = 'e-chart-rows-container';
export var scrollContent = 'e-content';
export var adaptive = 'e-device';
export var focusCell = 'e-grid';
// Timeline-Class
export var taskTable = 'e-task-table';
export var zeroSpacing = 'e-zero-spacing';
export var timelineHeaderContainer = 'e-timeline-header-container';
export var timelineHeaderTableContainer = 'e-timeline-header-table-container';
export var timelineHeaderTableBody = 'e-timeline-header-table-body';
export var timelineTopHeaderCell = 'e-timeline-top-header-cell';
export var timelineHeaderCellLabel = 'e-header-cell-label';
export var weekendHeaderCell = 'e-weekend-header-cell';
export var timelineSingleHeaderCell = 'e-timeline-single-header-cell';
export var timelineSingleHeaderOuterDiv = 'e-timeline-single-header-outer-div';
export var virtualTable = 'e-virtualtable';
export var virtualTrack = 'e-virtualtrack';
// Chart Rows-Class
export var leftLabelContainer = 'e-left-label-container';
export var leftLabelTempContainer = 'e-left-label-container e-left-label-temp-container';
export var leftLabelInnerDiv = 'e-left-label-inner-div';
export var rightLabelContainer = 'e-right-label-container';
export var rightLabelTempContainer = 'e-right-label-container e-right-label-temp-container';
export var rightLabelInnerDiv = 'e-right-label-inner-div';
export var taskBarMainContainer = 'e-taskbar-main-container';
export var parentTaskBarInnerDiv = 'e-gantt-parent-taskbar-inner-div';
export var parentProgressBarInnerDiv = 'e-gantt-parent-progressbar-inner-div';
export var taskLabel = 'e-task-label';
export var childTaskBarInnerDiv = 'e-gantt-child-taskbar-inner-div';
export var childProgressBarInnerDiv = 'e-gantt-child-progressbar-inner-div';
export var criticalChildTaskBarInnerDiv = 'e-gantt-child-critical-taskbar-inner-div';
export var criticalChildProgressBarInnerDiv = 'e-gantt-child-critical-progressbar-inner-div';
export var criticalMilestone = 'e-critical-milestone';
export var baselineBar = 'e-baseline-bar';
export var baselineMilestoneContainer = 'e-baseline-gantt-milestone-container';
export var baselineMilestoneDiv = 'e-baseline-gantt-milestone';
export var chartRowCell = 'e-chart-row-cell';
export var chartRow = 'e-chart-row';
export var rowExpand = 'e-row-expand';
export var rowCollapse = 'e-row-collapse';
export var collapseParent = 'e-collapse-parent';
export var collapseMultiTaskBar = 'e-gantt-multi-taskbar';
export var taskBarLeftResizer = 'e-taskbar-left-resizer';
export var taskBarRightResizer = 'e-taskbar-right-resizer';
export var childProgressResizer = 'e-child-progress-resizer';
export var progressBarHandler = 'e-progressbar-handler';
export var progressHandlerElement = 'e-progressbar-handler-element';
export var progressBarHandlerAfter = 'e-progressbar-handler-after';
export var icon = 'e-icon';
export var traceMilestone = 'e-gantt-milestone';
export var parentMilestone = 'e-gantt-parent-milestone';
export var traceChildTaskBar = 'e-gantt-child-taskbar';
export var traceChildProgressBar = 'e-gantt-child-progressbar';
export var manualParentMainContainer = 'e-manualparent-main-container';
export var manualParentTaskBar = 'e-gantt-manualparenttaskbar';
export var manualParentMilestone = 'e-gantt-manualparent-milestone';
export var manualChildTaskBar = 'e-gantt-child-manualtaskbar';
export var manualChildProgressBar = 'e-gantt-child-manualprogressbar';
export var manualParentRightResizer = 'e-gantt-manualparenttaskbar-right';
export var manualParentLeftResizer = 'e-gantt-manualparenttaskbar-left';
export var traceManualUnscheduledTask = 'e-gantt-unscheduled-manualtask';
export var traceParentTaskBar = 'e-gantt-parent-taskbar';
export var traceParentProgressBar = 'e-gantt-parent-progressbar';
export var traceUnscheduledTask = 'e-gantt-unscheduled-task';
export var criticalUnscheduledTask = 'e-gantt-critical-unscheduled-taskbar';
export var taskIndicatorDiv = 'e-indicator-span';
export var leftResizeGripper = 'e-left-resize-gripper';
export var rightResizeGripper = 'e-right-resize-gripper';
export var progressResizeGripper = 'e-progress-resize-gripper';
export var label = 'e-label';
export var templatePadding = 'e-template-padding';
//event Markers classes
export var eventMarkersContainer = 'e-event-markers-container';
export var eventMarkersChild = 'e-event-markers';
export var eventMarkersSpan = 'e-span-label';
//holiday classes
export var nonworkingContainer = 'e-nonworking-day-container';
export var holidayContainer = 'e-holiday-container';
export var holidayElement = 'e-holiday';
export var holidayLabel = 'e-span';
//weekend classes
export var weekendContainer = 'e-weekend-container';
export var weekend = 'e-weekend';
//Unscheduled Taskbar
export var unscheduledTaskbarLeft = 'e-gantt-unscheduled-taskbar-left';
export var unscheduledTaskbarRight = 'e-gantt-unscheduled-taskbar-right';
export var unscheduledTaskbar = 'e-gantt-unscheduled-taskbar';
export var unscheduledMilestoneTop = 'e-unscheduled-milestone-top';
export var unscheduledMilestoneBottom = 'e-unscheduled-milestone-bottom';
//Connector Line
export var dependencyViewContainer = 'e-gantt-dependency-view-container';
export var connectorLineContainer = 'e-connector-line-container';
export var connectorLine = 'e-line';
export var connectorLineSVG = 'e-connector-line';
export var criticalConnectorLineSVG = 'e-critical-line';
export var criticalConnectorArrowSVG = 'e-critical-line-arrow';
export var connectorLineArrow = 'e-connector-line-arrow';
export var criticalConnectorLine = 'e-criticalconnector-line';
export var criticalConnectorLineRightArrow = 'e-criticalconnector-line-right-arrow';
export var criticalConnectorLineLeftArrow = 'e-criticalconnector-line-left-arrow';
export var connectorLineRightArrow = 'e-connector-line-right-arrow';
export var connectorLineLeftArrow = 'e-connector-line-left-arrow';
export var connectorLineZIndex = 'e-connector-line-z-index';
export var connectorLineHover = 'e-connector-line-hover';
export var criticalConnectorLineHover = 'e-critical-connector-line-hover';
export var connectorLineHoverZIndex = 'e-connector-line-hover-z-index';
export var connectorLineRightArrowHover = 'e-connector-line-right-arrow-hover';
export var connectorLineLeftArrowHover = 'e-connector-line-left-arrow-hover';
export var criticalConnectorLineRightArrowHover = 'e-critical-connector-line-right-arrow-hover';
export var criticalConnectorLineLeftArrowHover = 'e-critical-connector-line-left-arrow-hover';
export var connectorTouchPoint = 'e-connectortouchpoint';
export var connectorPointLeft = 'e-connectorpoint-left';
export var connectorPointRight = 'e-connectorpoint-right';
export var connectorPointLeftHover = 'e-connectorpoint-left-hover';
export var connectorPointRightHover = 'e-connectorpoint-right-hover';
export var falseLine = 'e-gantt-false-line';
export var connectorTooltipTaskName = 'e-tooltiptaskname';
export var connectorTooltipFalse = 'e-predecessor-false';
export var connectorTooltipTrue = 'e-predecessor-true';
export var rightConnectorPointOuterDiv = 'e-right-connectorpoint-outer-div';
export var leftConnectorPointOuterDiv = 'e-left-connectorpoint-outer-div';
export var connectorPointAllowBlock = 'e-connectorpoint-allow-block';
export var ganttTooltip = 'e-gantt-tooltip';
// Context Menu
export var columnHeader = '.e-gridheader';
export var content = '.e-content';
export var editForm = '.e-gridform';
export var deleteIcon = 'e-delete';
export var saveIcon = 'e-save';
export var cancelIcon = 'e-cancel';
export var ascendingIcon = 'e-icon-ascending';
export var descendingIcon = 'e-icon-descending';
export var editIcon = 'e-edit';
export var indentIcon = 'e-indent';
export var outdentIcon = 'e-outdent';
export var addIcon = 'e-add';
export var criticalPathIcon = 'e-critical-path';
export var addAboveIcon = 'e-add-above';
export var addBelowIcon = 'e-add-below';
//Predecessor touch mode
export var activeParentTask = 'e-active-parent-task';
export var activeChildTask = 'e-active-child-task';
export var activeConnectedTask = 'e-active-connected-task';
export var touchMode = 'e-predecessor-touch-mode';
//Over allocation range container
export var rangeContainer = 'e-rangecontainer';
export var rangeChildContainer = 'e-rg-rangdiv';
export var rangeChildMiddleContainer = 'e-rg-middlerangdiv';
//Pop Up
export var constraintLabel = 'e-constraint-label';
export var drawPreviewTaskbar = 'e-draw-preview-taskbar';
